<mat-toolbar color="primary" class="footer main-footer">
    <img
        src="/images/avantor-white-txt.svg"
        alt=""
        width="159"
        height="20" />
    <span class="example-spacer"></span>

    <div class="navigations d-flex align-items-center">
        <div class="mr-3">
            &copy; {{ currentYear }} Avantor.
            {{ 'all.rights.reserved' | translate }}.
        </div>
        <div class="link" (click)="handleRedirectToHelp()">
            {{ 'help' | translate }}
        </div>
        <div class="divider"></div>
        <div class="link">
            <a
                class="link terms-of-use"
                href="https://www.avantorsciences.com/us/en/inventory-manager-terms-and-conditions"
                target="_new"
                >{{ 'terms.use' | translate }}</a
            >
        </div>
        <div class="divider"></div>
        <div class="link" (click)="openPrivacyPolicy()">
            {{ 'privacy.policy' | translate }}
        </div>
    </div>
</mat-toolbar>

<mat-toolbar color="primary" class="footer mobile-footer">
    <mat-toolbar-row class="d-flex justify-content-center">
        <img
            src="/images/avantor-white-txt.svg"
            alt=""
            width="159"
            height="20" />
    </mat-toolbar-row>
    <mat-toolbar-row class="d-flex justify-content-center toolbar-row">
        <div class="navigations d-flex align-items-center">
            <div>
                &copy; {{ currentYear }} Avantor.
                {{ 'all.rights.reserved' | translate }}.
            </div>
        </div>
    </mat-toolbar-row>
    <mat-toolbar-row class="d-flex justify-content-center toolbar-row">
        <div class="navigations d-flex align-items-center">
            <div class="link" (click)="handleRedirectToHelp()">
                {{ 'help' | translate }}
            </div>
            <div class="divider"></div>
            <div class="link">
                <a
                    class="link terms-of-use"
                    href="https://www.avantorsciences.com/us/en/inventory-manager-terms-and-conditions"
                    target="_new"
                    >{{ 'terms.use' | translate }}</a
                >
            </div>
            <div class="divider"></div>
            <div class="link" (click)="openPrivacyPolicy()">
                {{ 'privacy.policy' | translate }}
            </div>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
